module.exports = __webpack_public_path__ + "static/Ccards8-c04132cdc3b6a34358d4972434985453.png";